module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_photowedding_02@2x-2043732159df986108a451f2c6fd31c7.webp";